<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="openAddForm"  icon="el-icon-plus" plain>添加</el-button>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            prop="Id"
                            label="Id">
                        </el-table-column>
                        <el-table-column
                            prop="Commission"
                            label="佣金">
                        </el-table-column>
                        <el-table-column
                            prop="CriticalValue"
                            label="垫付金额">
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="300px">
                            <template slot-scope="scope">
                                <el-button type="success" plain @click="openUpdateForm(scope.row)">编辑</el-button>
                                  <el-button type="danger" plain @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="480px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="佣金" prop="Commission">
                    <el-input placeholder="请输入佣金" v-model="newModel.Commission"></el-input>
                </el-form-item>
                <el-form-item label="垫付金额" prop="CriticalValue">
                    <el-input placeholder="" v-model="newModel.CriticalValue"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getSwipeCommissionDetail, addSwipeCommissionDetail,delSwipeCommissionDetail,updateSwipeCommissionDetail } from '@/api/swipeCommission'
import { constantRoutes } from "@/router"
export default {
    data(){
        return {
            templateId: null,
            dialogFormVisible:false,
            formTitle:"",
            formId:null,
            bodyHeight:0,
            isLoading:false,
            newModel:{
                Commission:"",
                CriticalValue:"",
                templateId:""
            },
            rules: {
                Commission: [
                    { required: true, message: '请填写佣金', trigger: 'blur' }
                ]
            },
            tableData:[]
        }
    },
    created(){
        this.templateId = this.$route.query.templateId
        this.newModel.templateId = this.templateId
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
        this.menus = constantRoutes[0].children.filter(item => {
            return item.meta.showInMenu == true
        })
    },
    methods: {
        openUpdateForm(info) {
            this.newModel.Commission = info.Commission
            this.newModel.CriticalValue = info.CriticalValue
            this.formTitle = '编辑'
            this.dialogFormVisible = true
            this.formId = info.Id
        },
        submitForm() {
            if(this.formTitle == '新增')
                this.add()
            else
                this.update()
        },
        add(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    addSwipeCommissionDetail(this.newModel)
                    .then(() => {
                    this.$message({
                        message: "新增成功！",
                        type: 'success'
                    });
                    this.query()
                    this.dialogFormVisible = false
                    })
                    .catch(err => {
                        console.log(err)
                    })
                } else {
                    return false;
                }
            });
        },
        update(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    updateSwipeCommissionDetail(this.formId,this.newModel)
                    .then(() => {
                    this.$message({
                        message: "修改成功！",
                        type: 'success'
                    });
                    this.query()
                    this.dialogFormVisible = false
                    })
                    .catch(err => {
                        console.log(err)
                    })
                } else {
                    return false;
                }
            });
        },
        del(scope){
            this.$confirm('确认删除该群组吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                delSwipeCommissionDetail(scope.Id)
                    .then(() => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.tableData.forEach((item, index, arr)=>{
                            if(item==scope){
                                arr.splice(index, 1);
                            }
                        });
                    })
                    .catch(err => {
                        console.log(err)
                    })
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        query(){
            this.isLoading=true;
            getSwipeCommissionDetail(this.templateId).then(res => {
                this.tableData=res.data
                this.isLoading = false
                })
            .catch(err => {
                console.log(err)
                this.isLoading = false
            });
        },
        openAddForm(){
            this.newModel={
                Commission:"",
                CriticalValue:"",
                templateId : this.templateId
            };
            this.formTitle = '新增';
            this.dialogFormVisible=true;

        },
        reset(){
            this.queryModel={
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>